'use client'

import { type ReactNode } from 'react'
import { useParams } from 'next/navigation'
import {
  LoginWidget as CoreLoginWidget,
  // PlexBalance,
  LoginWidgetLink,
  LoginUser,
  AvatarIcon,
  LogOut,
} from '@ccpgames/eve-web-core'
// import { handleLogout } from '@/lib/auth/logout'
import { theme } from '@/styles/theme'

interface LoginWidgetClientProps {
  user: LoginUser
  menuHeader?: ReactNode
  staticLinks: LoginWidgetLink[]
  showNotificationBubble: boolean
  messages?: Record<string, string>
}

export function LoginWidgetClient({
  user,
  staticLinks,
  showNotificationBubble,
  menuHeader,
  messages,
}: LoginWidgetClientProps) {
  const params = useParams()
  const locale = (params?.locale as string) || 'en'

  const handleLogin = () => {
    // Get current page URL to redirect back after login
    const currentUrl = window.location.pathname + window.location.search
    const loginUrl = `/${locale}/login?callbackUrl=${encodeURIComponent(currentUrl)}`
    window.location.href = loginUrl
  }

  const handleLogout = () => {
    const logoutUrl = `/${locale}/logout`
    window.location.href = logoutUrl
  }

  // Combine static links with client-side logout link
  const allLinks: LoginWidgetLink[] = [
    ...staticLinks,
    {
      icon: <LogOut width={20} height={20} color="#777" />,
      title: messages?.logout || 'Logout',
      // onClick: handleLogout,
      onClick: handleLogout,
    },
  ]

  return (
    <CoreLoginWidget
      user={user}
      links={allLinks}
      menuHeader={menuHeader}
      onLogin={handleLogin}
      loginIcon={<AvatarIcon width={20} height={20} color={theme.colors?.mediumTurquoise?.[5] || '#5ccbcb'} />}
      primaryColor={theme.colors?.mediumTurquoise?.[5] || '#5ccbcb'}
      showNotificationBubble={showNotificationBubble}
    />
  )
}
